import { useApiQuery } from 'mf_core/query';
import { useIsAuthenticated } from 'mf_core/auth';

export function useIsCepWhitelisted(isProspectUser = false) {
  const isAuthenticated = useIsAuthenticated();
  const { data } = useApiQuery<boolean>(
    '/account-management/v1/widget-configurations/iscepwhitelisted',
    undefined,
    { enabled: isAuthenticated && !isProspectUser }
  );
  return data ?? true;
}
